export default __webpack_public_path__ + "static/media/questionCardBackground.21110d89.svg";